export enum UserAgentEventLogType {
  AGENT_STATUS = 'agent_status',
  QUEUE = 'queue',
  USER = 'user',
}

export const UserAgentEventLogTypeDescription = {
  [UserAgentEventLogType.AGENT_STATUS]: 'Agent Status',
  [UserAgentEventLogType.QUEUE]: 'Queue',
  [UserAgentEventLogType.USER]: 'User',
}

export interface UserAgentEventLog {
  id: number
  event_type: UserAgentEventLogType
  agent_status: string
  agent_availability: string
  call_center_user_agent_id: number
  extension_uuid: string
  pbx_id: number
  user_id: number
  initiated_by_user_id: number
  created_at: string
  logged_in: boolean
}
